// var slideout = new Slideout({
//   'panel': document.getElementById('panel'),
//   'menu': document.getElementById('menu'),
//   'padding': 300,
//   'tolerance': 70
// });


// // Toggle button
// document.querySelector('.toggle-button').addEventListener('click', function() {
//   slideout.toggle();

// });

// document.querySelector('.toggle-button-2').addEventListener('click', function() {
//   slideout.close();
// });

// slideout
// .on('beforeopen', function() {
//   this.panel.classList.add('panel-open');
// })
// .on('open', function() {
//   this.panel.addEventListener('click', close);
// })
// .on('beforeclose', function() {
//   this.panel.classList.remove('panel-open');
//   this.panel.removeEventListener('click', close);
// });

/************************************/
$('body').on('click', '.dropdown-toggle.mob-dropdown-menu > span', function(e) {
  e.preventDefault();
  e.stopPropagation();
  $(this).closest('.dropdown').toggleClass('open');
  if($(this).closest('.dropdown').hasClass('open')) {
    $(this).addClass('on-click-rotate');
  }
  else {
    $(this).removeClass('on-click-rotate');
  }
});

$('body').on('click', '#category_wrapper .hasmenu.cat_list_single.dropdown > a > i', function(e) {
  e.preventDefault();
  e.stopPropagation();
  /*var get_cur = $(this);
  $(this).closest('.dropdown').siblings('.hasmenu.cat_list_single.dropdown').find('a > i').each(function() {
    if($(this).closest('.dropdown').hasClass('open')) {
      $(this).closest('.dropdown').removeClass('open');
    }
  });*/
  $(this).closest('.dropdown').toggleClass('open');
  $(window).trigger('resize');
});
$('body').on('click', '#category_wrapper .hasmenu.cat_list_single.dropdown > a.cat_list_single_a', function(e) {
  e.preventDefault();
  e.stopPropagation();
  /*var get_cur = $(this);
  $(this).closest('.dropdown').siblings('.hasmenu.cat_list_single.dropdown').find('a').each(function() {
    if($(this).closest('.dropdown').hasClass('open')) {
      $(this).closest('.dropdown').removeClass('open');
    }
  });*/
  $(this).closest('.dropdown').toggleClass('open');
  $(window).trigger('resize');
});
/************************************/